<template>
  <div id="AppPasswordForceChange">
    <div style="height: 100px;" />
    <div class="modal-card" style="width: 600px;">
      <header class="modal-card-head" style="border: 1px solid #dbdbdb; padding-top: 0px; padding-bottom: 0px;">
        <img src="../assets/logo.png" width="90px;" height="auto;" />
        <p
          class="modal-card-title has-text-centered"
          style="color: whitesmoke"
        >スケジュール管理システム Philips SMS</p>
      </header>
      <section class="modal-card-body" style="border: 1px solid #dbdbdb;">
        <b-field label="初期パスワードを変更してください。" />
        <b-field label="" />
        <b-field label="新しいパスワード" :type="{'is-danger': errors.has('afterPassword')}" :message="errors.first('afterPassword')">
            <b-input
              name="afterPassword"
              data-vv-as="新しいパスワード"
              type="password"
              ref="afterPassword"
              v-model="newpassword"
              password-reveal
              placeholder="新しいパスワードを入力してください"
              v-validate="'required|min:8|max:16|password'"
            ></b-input>
        </b-field>
        <b-field label="新しいパスワード(確認)" :type="{'is-danger': errors.has('afterPasswordcomf')}" :message="errors.first('afterPasswordcomf')">
          <b-input
            name="afterPasswordcomf"
            data-vv-as="新しいパスワード(確認)"
            type="password"
            v-model="newpasswordcomf"
            password-reveal
            placeholder="新しいパスワード(確認)を入力してください"
            v-validate="'required|confirmed:afterPassword'"
          ></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot" style="border: 1px solid #dbdbdb;">
        <div>
          <b-button
            class="button is-light is-inverted has-text-centered"
            icon-left="key-change"
            v-on:click="passwordForceChange()"
          >パスワード変更</b-button>
        </div>
      </footer>
    </div>
    <div style="height: 100px;" />
  </div>
</template>

<script>
export default {
  name: "AppPasswordForceChange",
  data () {
    return {
      currentpassword : '',
      newpassword : '',
      newpasswordcomf:''
    }
  },
  created() {
    this.currentpassword = this.$route.params.currentpassword
  },
  methods: {
    passwordForceChange: function(event) {
      console.log("password force change called.");
      // TODO パスワードハッシュ化
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store
            .dispatch("passwordForceChange", {
              currentpassword: this.currentpassword,
              newpassword: this.newpassword
            })
            .then(() => {
              this.$router.push({ path: "/main/Welcome" });
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #061e57;
$primary-invert: findColorInvert($primary);
$info: #209cee;
$info-invert: findColorInvert($info);
$light: whitesmoke;
$light-invert: findColorInvert($light);
$success: #23d160;
$success-invert: findColorInvert($success);
$danger: #ff3860;
$danger-invert: #fff;
$background: #061e57;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  )
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>



// WEBPACK FOOTER //
// src/components/AppPasswordForceChange.vue